import React from 'react';
import { ListGroup } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import NavCollapse from '../NavCollapse';
import NavItem from '../NavItem';

const equals = (a, b) => {

    for (const value of b) {
      if(a.includes(value)) return true
    }
    return false;
  }

const NavGroup = ({ layout, group }) => {
    const account = useSelector((state) => state.account);
    const { data } = account;
    const userGroups = data["cognito:groups"] || [];

    let navItems = '';

    if (group.children) {
        const groups = group.children;
        navItems = Object.keys(groups).map((item) => {
            item = groups[item];
            //if(!item.grupos.includes(data["cognito:groups"])) return false;
            if(!item.grupos || equals(item.grupos, userGroups)) {
            switch (item.type) {
                case 'collapse':
                    return <NavCollapse key={item.id} collapse={item} type="main" />;
                case 'item':
                    return <NavItem layout={layout} key={item.id} item={item} />;
                default:
                    return null;
            }
            }
            return null;
        }).filter(Boolean);
    }

    // Si no hay elementos hijos visibles, no mostrar el grupo
    if (navItems.length === 0) return null;

    return (
        <React.Fragment>
            <ListGroup.Item as="li" bsPrefix=" " key={group.id} className="nav-item pcoded-menu-caption">
                <label>{group.title}</label>
            </ListGroup.Item>
            {navItems}
        </React.Fragment>
    );
};

export default NavGroup;
